import { lazy } from "react";
import routes from "../config/routes";
import About from "../pages/About";

// Lazy load secondary routes to optimize initial bundle size & load speed
const Skills = lazy(() => import("../pages/Skills"));
const Games = lazy(() => import("../pages/Games"));
const NotFound = lazy(() => import("../pages/404"));
const Projects = lazy(() => import("../pages/Projects"));
const Partner = lazy(() => import("../pages/Partner"));
const ProjectDetails = lazy(() => import("../pages/Projects/projectsInfo"));
const Pinterest = lazy(() => import("../pages/Pinterest"));
const NuoiToi = lazy(() => import("../pages/NuoiToi"));

const publicRoutes = [
  { path: routes.about, component: About },
  { path: routes.skill, component: Skills },
  { path: routes.games, component: Games },
  { path: routes.projects, component: Projects },
  { path: routes.partner, component: Partner },
  { path: routes.pinterest, component: Pinterest },
  { path: routes.nuoitoi, component: NuoiToi },
  { path: routes.projectDetails, component: ProjectDetails },
  { path: routes.notfound, component: NotFound },
];

const privateRoutes = [];

// Preload secondary routes during browser idle time for instantaneous tab switching
if (typeof window !== "undefined") {
  const preloadRoutes = () => {
    import("../pages/Skills");
    import("../pages/Games");
    import("../pages/Projects");
    import("../pages/Partner");
    import("../pages/Pinterest");
    import("../pages/NuoiToi");
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(preloadRoutes, { timeout: 2000 });
  } else {
    setTimeout(preloadRoutes, 1500);
  }
}

export { publicRoutes, privateRoutes };

